import { Component, forwardRef, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-slider',
    standalone: true,
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SliderComponent),
            multi: true
        }
    ],
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SliderComponent implements ControlValueAccessor {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public get value() {
        return this._value;
    }

    @Input()
    public set value(value: number) {
        this._value = value;
        this._onChange(value);
        this._onTouched(value);
    }

    @Input() public min: number;
    @Input() public max: number;
    @Input() public precision: number;
    @Input() public step: number;
    @Input() public hideTooltip: boolean;
    @Input() public divider: boolean;
    @Input() public ticks: string[];

    private _value: number;

    public registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    public writeValue(value: number): void {
        if (value !== null) {
            this._value = value;
            this.changeDetectorRef.markForCheck();
        }
    }

    public onChange(event: any): void {
        this.value = event.target.value;
    }

    private _onChange: any = () => {};
    private _onTouched: any = () => {};
}
